import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CheckboxModule, CheckboxChangeEvent } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { LucideAngularModule, Info, Route } from 'lucide-angular';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { ChartLogoPosition, ChartLogoSource } from '../../models';

@Component({
  selector: 'app-impact-chart-controls',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CheckboxModule,
    TooltipModule,
    SelectModule,
    SelectButtonModule,
    ButtonModule,
    PopoverModule,
    LucideAngularModule,
    TranslocoModule
  ],
  templateUrl: './impact-chart-controls.component.html',
  styles: []
})
export class ImpactChartControlsComponent {
  @Input() groupTransports: boolean = false;
  @Input() excludeMainTransport: boolean = false;
  @Input() logoSources: ChartLogoSource[] = [];
  @Input() logoPosition: ChartLogoPosition = 'none';
  @Input() logoSourceId: string | null = null;

  @Output() groupTransportsChange = new EventEmitter<boolean>();
  @Output() excludeMainTransportChange = new EventEmitter<boolean>();
  @Output() logoPositionChange = new EventEmitter<ChartLogoPosition>();
  @Output() logoSourceIdChange = new EventEmitter<string>();

  readonly infoIcon = Info;
  readonly routeIcon = Route;

  private transloco = inject(TranslocoService);

  logoPositionOptions: Array<{ label: string; value: ChartLogoPosition }> = [
    {
      label: this.transloco.translate('impact.overview.logo.positionNone'),
      value: 'none',
    },
    {
      label: this.transloco.translate('impact.overview.logo.positionCenter'),
      value: 'center',
    },
    {
      label: this.transloco.translate('impact.overview.logo.positionSide'),
      value: 'side',
    },
  ];

  onGroupTransportsChange(event: CheckboxChangeEvent): void {
    const checked = event.checked ?? false;
    this.groupTransportsChange.emit(checked);
  }

  onExcludeMainTransportChange(event: CheckboxChangeEvent): void {
    const checked = event.checked ?? false;
    this.excludeMainTransportChange.emit(checked);
  }

  onLogoPositionChange(position: ChartLogoPosition): void {
    this.logoPositionChange.emit(position);
  }

  onLogoSourceChange(sourceId: string): void {
    this.logoSourceIdChange.emit(sourceId);
  }
}
